<template>
    <ul id="login-list" class="row">

      <li class="col d-md-none d-lg-flex p-0" v-if="!isLoggedIn">
        <template v-if="showRegistration">
          <a data-testing="register-select" :href="isRegister ? 'javascript:void(0)' : '#registration'"
             :data-toggle="isRegister ? false : 'modal'" @click="createRegisterModal(); unmarkInputFields();"
             :aria-label="$translate('Ceres::Template.loginRegister')">
            <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginRegister") }}</span>
          </a>
        </template>
      </li>

      <li class="col p-0" v-if="!isLoggedIn">
        <a data-testing="login-select" v-if="showLogin"
           :href="isLogin ? 'javascript:void(0)' : '#login'"
           :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();"
           :aria-label="$translate('Ceres::Template.login')">
          <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.login") }}</span>
        </a>
      </li>

      <li class="col dropdown" v-if="isLoggedIn">
        <a href="#" class="dropdown-toggle" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true"
           aria-expanded="false" data-boundary="window">
          <i class="fa fa-user" aria-hidden="true"></i>
          <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginMyAccount") }}</span>
        </a>

        <div class="dropdown-menu small m-0 p-0 mw-100">
          <div class="list-group" aria-labelledby="accountMenuList">
            <a :href="$ceres.urls.myAccount" class="list-group-item small"><i class="fa fa-user"></i> {{
              $translate("Ceres::Template.loginMyAccount") }}</a>
            <a href="#" class="list-group-item small" v-logout><i class="fa fa-sign-out"></i> {{
              $translate("Ceres::Template.loginLogout") }}</a>
          </div>
        </div>
      </li>

      <li class="col p-0" @mouseover.once="$store.dispatch('loadComponent', 'basket-preview')">
        <a v-toggle-basket-preview href="#" class="toggle-basket-preview">
          Warenkorb
          <span class="badge-right-count"
                v-bind:class="{'d-none' : $store.state.basket.data.itemQuantity == 0}">{{$store.state.basket.data.itemQuantity}}</span>
          <icon icon="shopping-cart" class-loading="fa-refresh" :loading="$store.state.basket.isBasketLoading"></icon>
        </a>
      </li>

    </ul>
</template>

<script>
import ValidationService from "../../../services/ValidationService";
import {mapGetters, mapActions} from "vuex";

export default {
  props: {
    showRegistration: {
      type: Boolean,
      default: true
    },
    showLogin: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters([
      "isLoggedIn"
    ])
  },

  data() {
    return {
      isLogin: App.templateType === "login",
      isRegister: App.templateType === "register"
    };
  },

  methods: {
    unmarkInputFields() {
      ValidationService.unmarkAllFields($("#login"));
      ValidationService.unmarkAllFields($("#registration"));
    },

    createLoginModal() {
      this.loadComponent("login-modal");
    },

    createRegisterModal() {
      this.loadComponent("register-modal");
    },

    ...mapActions([
      "loadComponent"
    ])
  }
}
</script>
